import React, {cloneElement} from 'react';

import SubMenu from './SubMenu.jsx';
import { requireJrMode } from '../../utils/Util.js';

class Menu extends React.Component {

    state = {
        opened: []
    }

    // Listen for touch start event to close the opened menus on touching outside
    onDocumentClick = (e) => {
        if(this.state.opened.length > 0) {
            let target = e.target;
            while (target) {
                if (target.classList && target.classList.contains('tde-dropdown-menu')) {
                    return;
                }
                target = target.parentElement;
            }
            this.clearOpened();
        }
    }
    componentDidMount () {
        document.addEventListener('touchstart', this.onDocumentClick);
    }
    componentWillUnmount () {
        document.removeEventListener('touchstart', this.onDocumentClick);
    }

    clearOpened = () => {
        this.setState({
            opened: []
        });
    }

    setOpen = (isOpen, key) => {
        clearTimeout(this.timeoutdelay);
        let keys = [];
        let timeoutValue = 100;
        switch(isOpen) {
            // To add new key in the open keys
            case 1:
                keys = key.split('_');
                break;
            // To remove last item from the open keys
            case 0:
                keys = key.split('_');
                keys.splice(-1, 1);
                // Set timeout value to 0 since it is a keyboard event
                timeoutValue = 0;
                break;
            // Clean all open keys
            case -1:
                keys = [];
                break;
        }
        this.timeoutdelay = setTimeout(() => {
            for(var i= 1; i < keys.length; i++) {
                keys[i] = keys[i-1] + '_' + keys[i];
            }
            this.setState({
                opened: keys
            });
        }, timeoutValue);
    }

    onKeyUp = (e) => {
        this.shiftPressed = false;
    }

    onKeyDown = (e) => {
        let _liEle = e.target;
        switch(e.key) {
            case 'ArrowRight':
                e.preventDefault();
                if(_liEle.dataset.level == 0) {
                    this.focusNextSibling(_liEle);
                } else if(_liEle.dataset.level == 1) {
                    let _subUl = _liEle.querySelectorAll('ul');
                    if(_subUl.length) {
                        _subUl[0].childNodes[0].childNodes[0].focus();
                    }
                }
                break;
            case 'ArrowLeft':
                e.preventDefault();
                if(this.props.direction === 'vertical' && _liEle.dataset.level == 2) {
                    // To change the event as esc
                    e.key = 'Escape';
                    this.props.onMouseLeave(e);
                    break;
                }
                if(_liEle.dataset.level == 0) {
                    this.focusPreviousSibling(_liEle);
                } if(_liEle.dataset.level == 2) {
                    _liEle.parentNode.parentNode.childNodes[0].focus();
                }
                break;
            case 'ArrowUp':
                e.preventDefault();
                if(_liEle.dataset.level == 1 || _liEle.dataset.level == 2) {
                    if(_liEle.previousSibling) {
                        this.focusPreviousSibling(_liEle);
                    }
                }
                break;
            case 'ArrowDown':
                e.preventDefault();
                if(_liEle.dataset.level == 1 || _liEle.dataset.level == 2) {
                    this.focusNextSibling(_liEle);
                }
            break;
            case 'Escape':
                // e.target.blur();
                if(this.props.onMouseLeave) {
                    this.props.onMouseLeave(e);
                }
            break;
            case 'Shift':
                this.shiftPressed = true;
                break;
            case 'Tab':
                if(this.props.tabPressed) {
                    e.preventDefault();
                    this.props.tabPressed(this.shiftPressed /* isShifted */);
                }
                break;
        }
    }

    // To set focus on next sibling
    focusNextSibling = (ele) => {
        if(ele.nextSibling) {
            if(ele.nextSibling.getAttribute('role') === 'separator') {
                ele.nextSibling.nextSibling.focus();
            } else {
                ele.nextSibling.focus();
            }
            /*
            let children = ele.nextSibling.childNodes;
            // To focus the immediate li which has no divider
            if(!children.length) {
                children = ele.nextSibling.nextSibling.childNodes;
            }
            children[0].focus();
            */
        } else {
            ele.focus()
        }
    }

    // To set focus on previous sibling
    focusPreviousSibling = (ele) => {
        if(ele.previousSibling) {
            if(ele.previousSibling.getAttribute('role') === 'separator') {
                ele.previousSibling.previousSibling.focus();
            } else {
                ele.previousSibling.focus();
            }
            /*
            let children = ele.previousSibling.childNodes;
            // To focus the immediate li which has no divider
            if(!children.length) {
                children = ele.previousSibling.previousSibling.childNodes;
            }
            children[0].focus();
            */
        } else {
            ele.focus()
        }
    }

    getWidth = () => {
        return this._domNode.clientWidth;
    }

    /**
     * To get max fitable children count based on available width
     */
    getfitableChildrenCount = (mode) => {
        const _requireJrMode = requireJrMode(mode);
        let childCount = 0;
        let childrenWidth = _requireJrMode? 0: 5;
        let availableWidth = this.getWidth();
        let children = this._domNode.childNodes;
        for(let i = 0; i < children.length; i++) {
            let style = children[i].currentStyle || window.getComputedStyle(children[i])
            let width = children[i].clientWidth,
            margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight),
            padding = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight),
            border = parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);
            const menuWidth = width + margin + border + padding;
            childrenWidth += menuWidth;
            if(childrenWidth <= availableWidth) {
                childCount++;
            } else {
                // In elementary mode if a menu width is less than 60px then
                // one more child count has to be reduced to accomodate more button
                if(_requireJrMode) {
                    const smallMenuWidth = 54;
                    const largeMenuWidth = 86;
                    const availabeSpaceAtTheEnd = availableWidth - (childrenWidth - menuWidth);
                    if(menuWidth <= smallMenuWidth && availabeSpaceAtTheEnd < (largeMenuWidth - smallMenuWidth)) {
                        childCount--;
                    }
                }
                break;
            }
        }
        return childCount;
    }

    // This function will be called to select next parent menu when tab pressed on submenus
    _tabPressed = (isShifted, _liEle) => {
        if(isShifted) {
            this.focusPreviousSibling(_liEle);
        } else {
            this.focusNextSibling(_liEle);
        }
        this.setState({opened: []});
    }

    render () {
        const { children, className, direction, tabPressed, role, id, ...props } = this.props;
        var _children = React.Children.map(children, child => {
            var _props = {
                onKeyDown: this.onKeyDown,
                onKeyUp: this.onKeyUp
            };
            if(child.type == SubMenu) {
                _props.opened = child.props.opened || this.state.opened;
                _props.setOpen = child.props.setOpen || this.setOpen;
                _props.tabPressed = tabPressed || this._tabPressed;
                _props.direction = direction;
            } else {
                if(this.props.onMouseEnter) {
                    _props.onMouseEnter = (e) => {
                        this.props.onMouseEnter(e);
                    };
                }
                if(this.props.onMouseLeave) {
                    _props.onMouseLeave = (e) => {
                        this.props.onMouseLeave(e);
                    };
                }
            }
            child = cloneElement(child, _props);
            return child;
        });

        // Optional ARIA attributes - only add if explicitly provided
        const ariaProps = {};
        if (role) {
            ariaProps.role = role;
        } else if (!role && !id) {
            // Default to menubar only if no custom role/id specified (backward compatibility)
            ariaProps.role = "menubar";
        }
        if (id) {
            ariaProps.id = id;
        }

        return (
        <div
            ref={_domNode => {this._domNode = _domNode}}
            {...ariaProps}
            className={`tde-menu ` + (className || '') + (direction === 'horizontal'? ' tde-horizontal tde-primary-text-color': ' tde-vertical')}
            {...props}>
            {_children}
        </div>
        )
    }
}

export default Menu
